module.exports = __webpack_public_path__ + "static/media/president-suite-img2.da9b313e.jpg";